import { ABSENCE_LETTER_VERSION } from "../../../../../constants/version";
import AbsenceLetterDetail from "../../absence-letter-v1/pages/absence-letter/absence-letter-detail";
import AbsenceLetterCreate from "../../absence-letter/pages/absence-letter/absence-letter-create";
import AbsenceLetterDetailV2 from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import AbsenceLetterEdit from "../../absence-letter/pages/absence-letter/absence-letter-edit";
import AbsenceLetterDAD from "../../absence-letter-v1/pages/absence-letter/absence-letter-list/absence-letter-dad";
import AbsenceLetterDADV2 from "../../absence-letter/pages/absence-letter/absence-letter-list/absence-letter-dad";

export const absenceLetterDADRoutes = {
  absenceLetterDADPage: {
    isAdmin: false,
    title: "1. Đơn xin nghỉ phép",
    path: "/procedure/absence-letter-dad",
    parentId: "procedure",
    component: () => {
      return ABSENCE_LETTER_VERSION === 1 ? <AbsenceLetterDAD /> : <AbsenceLetterDADV2 />;
    },
  },
  createAbsenceLetterDADPage: {
    isAdmin: false,
    path: "/procedure/absence-letter-dad/create",
    parentId: "procedure",
    component: AbsenceLetterCreate,
  },
  detailAbsenceLetterDADPage: {
    isAdmin: false,
    path: "/procedure/absence-letter-dad/:applicationForLeaveId",
    parentId: "procedure",
    component: ABSENCE_LETTER_VERSION === 1 ? AbsenceLetterDetail : AbsenceLetterDetailV2,
  },
  editAbsenceLetterDADPage: {
    isAdmin: false,
    path: "/procedure/absence-letter-dad/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: AbsenceLetterEdit,
  },
};
